(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"Release-ris-v1.1.1.1"};


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 523
// module chunks = 86